import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { logger } from 'Common/utils';
import { ErrorBoundary } from 'Shared/components';
import ErrorPlaceholder from '../ErrorPlaceholder/ErrorPlaceholder';
const PageErrorBoundary = ({ pageName, children, logErrors = true }) => (_jsx(ErrorBoundary, Object.assign({ logger: logger, logErrors: logErrors, errorPlaceholder: _jsx(ErrorPlaceholder, { message: `Application failed to render the ${pageName ? `${pageName} ` : ''}page due to errors on the client side` }, void 0) }, { children: children }), void 0));
export default memo(PageErrorBoundary);
